export default "__VITE_ASSET__CHAZaBaS__"